<template>
    <div class="ds-staff-section-title">Штатное расписание</div>
    <div class="ds-staff-table-header">
        <div>Должность</div>
        <div>График</div>
        <div>Количество</div>
    </div>
    <StaffItem v-for="item in items" :key="item.position_id" :item />
</template>

<script setup lang="ts">
import { Staff } from '@/types';
import StaffItem from './StaffItem.vue';
interface Props {
    items: Staff[]
}

defineProps<Props>()
</script>
